"use client";

import Image from "next/image";
import { Tabs } from "../ui/Tabs";
import DummyContent from "./DummyContent";

export function CategoryTab() {
  const tabs = [
    {
      title: "Data Analytics",
      value: "data-analytics",
      content: (
        <div className="w-full overflow-hidden relative h-full rounded-2xl p-10 text-white bg-black">
          <p className="text-xl font-bold uppercase">What is Data Analytics ?</p>
          <DummyContent 
            initDescription="Data analytics is the process of turning raw data into meaningful,
        actionable insights. You can think of it as a form of business
        intelligence, used to solve specific problems and challenges within an
        organization. It’s all about finding patterns in a dataset which can
        tell you something useful and relevant about a particular area of the
        business—how certain customer groups behave, for example, or why sales
        dipped during a given time period.  A data analyst takes the raw data
        and analyzes it to draw out useful insights. They then present these
        insights in the form of visualizations, such as graphs and charts, so
        that stakeholders can understand and act upon them. The kinds of
        insights gleaned from the data depends on the type of analysis
        performed. There are four main types of analysis used by data experts"
          />
        </div>
      ),
    },
    {
      title: "Web Development",
      value: "web-development",
      content: (
        <div className="w-full overflow-hidden relative h-full rounded-2xl p-10 text-xl md:text-4xl font-bold text-white bg-black">
          <p>Web Development</p>
          <DummyContent />
        </div>
      ),
    },
    {
      title: "Content Writing",
      value: "content-writing",
      content: (
        <div className="w-full overflow-hidden relative h-full rounded-2xl p-10 text-xl md:text-4xl font-bold text-white bg-black">
          <p>Content Writing</p>
          <DummyContent />
        </div>
      ),
    },
    {
      title: "Digital Marketing",
      value: "digital-marketing",
      content: (
        <div className="w-full overflow-hidden relative h-full rounded-2xl p-10 text-xl md:text-4xl font-bold text-white bg-black">
          <p>Digital Marketing</p>
          <DummyContent />
        </div>
      ),
    },
  ];

  return (
    <div className="container px-6 py-8 m-auto md:py-14 md:px-16 lg:px-56 lg:py-0 -mt-20">
      <div className="h-[20rem] md:h-[30rem] flex flex-col max-w-5xl mx-auto w-full items-start justify-start my-40">
        <Tabs tabs={tabs} />
      </div>
    </div>
  );
}

